$(document).on("common_required_loading rendered", {}, function(event, uniqueId){
    var $this = $("#" + uniqueId);

    // console.log(event);
    // console.log(uniqueId);
    // console.log($this);

    $this.children(".loading").removeClass("active");

});